import { render, staticRenderFns } from "./PopinDeleteElement.vue?vue&type=template&id=2c336ec9&scoped=true&"
import script from "./PopinDeleteElement.vue?vue&type=script&lang=js&"
export * from "./PopinDeleteElement.vue?vue&type=script&lang=js&"
import style0 from "./PopinDeleteElement.vue?vue&type=style&index=0&id=2c336ec9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c336ec9",
  null
  
)

export default component.exports